export default __webpack_public_path__ + "static/screenshot6-97ea4871c6b370205fe904642245ef98.jpg";